export const options = {
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: true,
  processing: true,
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [5, 10, 20, 40, 80, 160, 200],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
  buttons: [
    {
      text: "Select All",
      action: function (_, dt) {
        dt.rows().select();
      },
    },
    {
      text: "Deselect All",
      action: function (_, dt) {
        dt.rows().deselect();
      },
    },
    {
      extend: "csvHtml5",
      text: "CSV",
      title: "Central",
      exportOptions: {
        columns: [0, 1, 2, 3, 4, 5],
      },
      customizeData: (data) => {
        const dt = this;
        const selectedRows = dt.rows({ selected: true }).data().toArray();
        if (selectedRows.length > 0) {
          data.body = selectedRows.map((row) => Object.values(row));
        } else {
          const allRows = dt.rows().data().toArray();
          data.body = allRows.map((row) => Object.values(row));
        }
      },
    },
  ],
};

export const columns = [
  { title: "id", data: "id", visible: false },
  { title: "Tag", data: "tag" },
  { title: "IMEI", data: "imei" },
  { title: "ICCID", data: "iccid" },
  { title: "CLASS", data: "class" },
  { title: "TYPE", data: "type" },
  { title: "Last Fix", data: "last_fix" },
  { title: "Build", data: "build" },
  {
    title: "Actions",
    data: null,
    defaultContent: "",
    orderable: false,
    render: (data) => {
      const rowData = JSON.stringify(data).replace(/"/g, "&quot;");
      return `<button class="btn btn-warning view-device-btn w-100" data="${rowData}">VIEW LOGS</button>`;
    },
  },
];
